import * as React from "react";
const SvgFiRrRadiationAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-radiation-alt_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m7.975-11.326a8.09 8.09 0 0 0-2.446-4.585 2.08 2.08 0 0 0-1.644-.545 2 2 0 0 0-1.438.889l-1.745 2.651a3 3 0 0 0-1.404 0L9.553 6.433a2 2 0 0 0-1.438-.889 2.07 2.07 0 0 0-1.645.545c-.46.433-.87.92-1.221 1.451a8 8 0 0 0-1.224 3.135A2.004 2.004 0 0 0 5.998 13h3.173c.142.4.366.761.652 1.062-.382.689-1.052 1.875-1.514 2.578a1.88 1.88 0 0 0-.235 1.571c.153.523.524.951 1.019 1.172.918.41 1.896.618 2.906.618s1.987-.208 2.905-.618a1.85 1.85 0 0 0 1.019-1.173c.155-.534.069-1.107-.207-1.523l-1.531-2.636c.282-.3.503-.659.643-1.055l3.151-.006c.596 0 1.158-.262 1.545-.717a1.98 1.98 0 0 0 .449-1.601zM13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7-1.004a6 6 0 0 1 .92-2.356c.264-.399.572-.768.963-1.107l1.739 2.642a3 3 0 0 0-.45.825zm4.058 6.625c.508-.791 1.179-1.981 1.548-2.648a3 3 0 0 0 .808-.002l1.563 2.636a5.16 5.16 0 0 1-3.919.014m4.777-6.603a3 3 0 0 0-.45-.836l1.777-2.634c.347.324.655.692.918 1.092.474.72.783 1.513.898 2.352-1.411.002-2.42.003-3.143.027z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-radiation-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRadiationAlt;
